export default __webpack_public_path__ + "static/media/D2022_09_11_Sonora.77bee640.jpg";